// Mirrors `fieldUsagesTypes` in the API reference data; only the livestock usages are needed here.
export const fieldUsages = {
  Grazing: 0,
  Mixed: 3,
  Silvopastoral: 5,
} as const
